import { globalQueryKeys } from '../global-query-keys';

export const USER_FILES_API_URL = 'ui/organization/user_files';

export const userFilesQueryKeys = {
  global: [...globalQueryKeys.files],
  all: () => [...userFilesQueryKeys.global, USER_FILES_API_URL],
};
